import React, { useState } from "react";
import FormContext from "./FormContext";

const FormState = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [FormList, setFormList] = useState([]);

  const [Loading, setLoading] = useState(false);

  const FormInputOptions = [
    {
      Name: "Text",
      Type: "text",
      LiId: "text",
      Component: "Text",
      Icon: <i className=" px-2 fa-regular fa-id-badge"></i>,
    },
    {
      Name: "Select",
      Type: "select",
      LiId: "select",
      Component: "Select",
      Icon: <i className="px-2 fa-regular fa-square-caret-down"></i>,
    },
    {
      Name: "Email",
      Type: "email",
      LiId: "email",
      Component: "Email",
      Icon: <i className="px-2 fa-regular fa-envelope"></i>,
    },
    {
      Name: "Mobile Number",
      Type: "number",
      LiId: "Mobile Number",
      Component: "MobileNumber",
      Icon: <i className="px-2 fa-solid fa-arrow-up-1-9"></i>,
    },
    {
      Name: "Number",
      Type: "number",
      LiId: "number",
      Component: "Number",
      Icon: <i className="px-2 fa-solid fa-arrow-up-1-9"></i>,
    },

    {
      Name: "CheckBox",
      Type: "checkbox",
      LiId: "checkbox",
      Component: "CheckBox",
      Icon: <i className="px-2 fa-regular fa-square-check"></i>,
    },
    // {
    //   Name: "Radio",
    //   Type: "radio",
    //   LiId: "radio",
    //   Icon: <i className="px-2 fa-regular fa-circle-dot"></i>,
    // },
    {
      Name: "File",
      Type: "file",
      LiId: "file",
      Component: "File",
      Icon: <i className="px-2 fa-regular fa-file-lines"></i>,
    },

    {
      Name: "Date",
      Type: "date",
      LiId: "date",
      Component: "Date",
      Icon: <i className="px-2 fa-regular fa-calendar-days"></i>,
    },
    {
      Name: "TextArea",
      Type: "textarea",
      LiId: "textarea",
      Component: "TextArea",
      Icon: <i className="px-2 fa-solid fa-paragraph"></i>,
    },
  ];

  const [Fields, setFields] = useState([
    {
      id: 1,
      labelName: "Full Name",
      isRequired: true,
      formType: "",
      labelType: "text",
      column_name: "udf2",

      Component: "Text",
      mandatory: true,
    },
    {
      id: 2,
      labelName: "Mobile No",
      isRequired: true,
      formType: "",
      column_name: "udf1",
      labelType: "number",
      Component: "MobileNumber",
      mandatory: true,
    },
    {
      id: 3,
      labelName: "Email ID",
      isRequired: true,
      formType: "",
      column_name: "udf4",
      labelType: "email",
      Component: "Email",
      mandatory: true,
    },
    {
      id: 4,
      labelName: "Amount",
      isRequired: true,
      formType: "",
      column_name: "udf10",
      labelType: "number",
      mandatory: true,
      Component: "Amount",
    },
  ]);

  const [countid, setCountId] = useState(5);
  const [AccordionData, setAccordionData] = useState([{}]);
  const [udf, setudf] = useState(11);

  const handleSidebar = (id, com) => {
    const extraoptionarr = ["select", "radio", "Terms_Conditions"];

    if (extraoptionarr.includes(id)) {
      setFields(
        Fields.concat({
          id: countid,
          labelName: "",
          isRequired: true,
          column_name: `udf${udf}`,
          formType: "",
          labelType: id,
          Component: com,
          mandatory: false,
          moreoption: [],
        })
      );
      setudf(udf + 1);
      setCountId(countid + 1);
    } else {
      setFields(
        Fields.concat({
          id: countid,
          labelName: "",
          Component: com,
          column_name: `udf${udf}`,
          isRequired: true,
          formType: "",
          labelType: id,
          mandatory: false,
        })
      );
      setudf(udf + 1);
      setCountId(countid + 1);
    }
  };

  const handlefieldremove = (id) => {
    let newFilds = Fields.filter((item) => item.id !== id);

    setFields(newFilds);
  };

  const [FormInfo, setFormInfo] = useState({});

  const [formResponse, setResponse] = useState({});

  const handleResponse = (e) => {
    setResponse({ ...formResponse, [e.target.name]: e.target.value });
  };

  const [Branch, setBranch] = useState({
    name: "Nagpur",
    path: "asdfasdf",
  });

  return (
    <FormContext.Provider
      value={{
        Branch,
        setBranch,
        formResponse,
        handleResponse,
        setFormList,
        handleSidebar,
        FormList,
        sidebarToggle,
        setSidebarToggle,
        FormInputOptions,
        AccordionData,
        setAccordionData,
        Fields,
        setFields,
        handlefieldremove,
        Loading,
        setLoading,
        FormInfo,
        setFormInfo,
        setResponse,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export default FormState;
